'use client'

import type { ReactNode } from 'react'
import { Providers } from '../providers'
import { ExternalDomMutationGuard } from '@/components/ExternalDomMutationGuard'
import { BrowserWarning } from '@/components/BrowserWarning'
import { AppShell } from '@/components/AppShell'
import { DesktopUpdatePrompt } from '@/components/DesktopUpdatePrompt'
import { StaleBuildPrompt } from '@/components/StaleBuildPrompt'
import { YdocRecoverySnapshot } from '@/components/YdocRecoverySnapshot'

// Client-only wrapper around the app's user-context providers. Kept separate
// from the (app) root layout so the layout itself can stay a server component
// (needed for cookies/headers and getMessages).
export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <Providers>
      <ExternalDomMutationGuard>
        <BrowserWarning />
        <DesktopUpdatePrompt />
        <StaleBuildPrompt />
        <YdocRecoverySnapshot />
        {/* Renders the one persistent app header; routes opt in via useAppHeader(). */}
        <AppShell>{children}</AppShell>
      </ExternalDomMutationGuard>
    </Providers>
  )
}
